import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import InfoProcessing, { IProps } from './index';

const mapStateToProps = (state: ApplicationState): IProps => {
  return {
    sectionTitle: state.student.config.Checklist.Consents.shortTitle,
    currentStep: 3,
    steps: 3,
    consent: state.student.consents.isPage3Complete,
    config: state.student.config.Checklist.Consents,
    configVisaSupport: state.student.config.otherOptions.visaSupport,
    visaSupportLocked: state.student.offer.visaSupportLocked,
  };
};

export default connect(mapStateToProps)(InfoProcessing);
